import { IAppState } from '../../../../../AppModulesWrapper';
import { createSelector } from 'reselect';
import { selectIsServicesEnabled } from './selectIsServicesEnabled';
import { selectIsDisabledPromotion } from '../../../../selectors/publishTerms';

export const selectIsServicesPromotionToggleChecked = createSelector(
  (state: IAppState) => selectIsServicesEnabled(state),
  (state: IAppState) => selectIsDisabledPromotion(state),
  (isServicesEnabled, isPromotionDisabled) => {
    return isPromotionDisabled ? false : isServicesEnabled;
  },
);
